import { SUPPORT_EMAIL } from '../components/common/SupportLink/SupportLink';
import { POLICYSTREAM_SUPPORT_EMAIL } from '../components/PolicyStream/constants';
import { useIsPolicyStreamOrganization } from '../components/PolicyStream/hooks/useIsPolicyStreamOrganization';

export const useSupportEmail = () => {
  const onPolicystream = useIsPolicyStreamOrganization();
  return onPolicystream ? POLICYSTREAM_SUPPORT_EMAIL : SUPPORT_EMAIL;
};
